"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Gateway = void 0;
var LOGGER_URL = 'https://logs.qleanlabs.ru/logstash';
var LOGGER_TIMEOUT = 2000;

var Gateway =
/** @class */
function () {
  function Gateway() {
    this.buffer = [];
  }

  Gateway.prototype.setConfig = function (config) {
    if (config.url) LOGGER_URL = config.url;
    if (config.timeout) LOGGER_TIMEOUT = config.timeout;
  };

  Gateway.prototype.pushLog = function (item) {
    var _this = this;

    this.buffer.push(item);

    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    this.timeout = setTimeout(function () {
      return _this.send();
    }, LOGGER_TIMEOUT);
  };

  Gateway.prototype.send = function () {
    var _this = this;

    var request = new XMLHttpRequest();
    request.addEventListener('readystatechange', function () {
      if (request.readyState === XMLHttpRequest.DONE && request.status === 429) {
        setTimeout(function () {
          return _this.send();
        }, LOGGER_TIMEOUT);
      } else if (request.readyState === XMLHttpRequest.DONE && request.responseText === 'ok') {
        _this.buffer = [];
      }
    });
    request.open('POST', LOGGER_URL);
    request.setRequestHeader('Content-Type', 'application/json');
    request.send(JSON.stringify(this.buffer));
  };

  return Gateway;
}();

exports.Gateway = Gateway;